import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["showPassword", "toggleShowPassword", "error"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Field.scss';
import './PasswordField.scss';
var PasswordField = function PasswordField(_ref) {
  var showPassword = _ref.showPassword,
    toggleShowPassword = _ref.toggleShowPassword,
    error = _ref.error,
    input = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('Field PasswordField', {
      error: !!error
    })
  }, /*#__PURE__*/React.createElement("input", _extends({}, input, {
    id: input.name,
    type: showPassword ? 'text' : 'password'
  })), /*#__PURE__*/React.createElement("button", {
    className: "password-visibility-button",
    onClick: toggleShowPassword,
    type: "button"
  }, showPassword ? 'Hide' : 'Show'));
};
PasswordField.propTypes = {
  error: PropTypes.object,
  showPassword: PropTypes.bool,
  toggleShowPassword: PropTypes.func
};
export default PasswordField;